// Set interval
const load_review_badge = setInterval(function(){
    if(jQuery('.grp-entangle-badge-title').length > 0){        
        jQuery('.grp-entangle-badge-title').text('Ausgezeichnet');
        var link_text = jQuery('.grp-main-hyper-link').html();
        link_text = link_text.replace('Bezogen auf','Basierend auf');
        link_text = link_text.replace('Rezensionen','Bewertungen');
        jQuery('.grp-entangle-badge-vertical .grp-main-hyper-link').html(link_text);        
        clearInterval(load_review_badge);        
    }
},1000);
